import ActionTypes from '../constants/ActionTypes';
import { apiInternal } from '../../../utilities/clients';

export default function approvePendingUser(id) {
  return {
    types: [
      ActionTypes.APPROVE_PENDING_USER_REQUEST,
      ActionTypes.APPROVE_PENDING_USER_SUCCESS,
      ActionTypes.APPROVE_PENDING_USER_FAILURE,
    ],
    callAPI(state) {
      return apiInternal.users(state).putStatusById(id, {
        body: JSON.stringify({
          status: 'active',
        }),
      });
    },
    payload: { id },
  };
}
